import TimeActivityEndpoint from '@spa/apps/trustup-pro-planning-js/endpoints/TimeActivityEndpoint';
import TrustUpIOTaskTimeActivityCollection from '@spa/apps/trustup-pro-worksite-js/collections/TrustUpIOTaskTimeActivityCollection';

export default class TrustUpIOTaskTimeActivityEndpoint extends TimeActivityEndpoint
{

    setTask(uuid)
    {
        this.task = uuid;
        return this;
    }

    async index()
    {
        const searchParams = new URLSearchParams({task: this.task});

        let data = await this.request(
            `${this.path}/table?${searchParams.toString()}`
        );

        data[this.responseKeyPlural] = new TrustUpIOTaskTimeActivityCollection(
            data[this.responseKeyPlural],
            this.task
        );
        
        return data;
    }

}